/**
 * Gets the cookie name suffix based on the hostname of the window's current location.
 * @returns Cookie name suffix
 */
const getCookieNameSuffix = () => `_${window.location.hostname}`;

export { getCookieNameSuffix };
